import { EMPTY, of } from 'rxjs';
import { filter, mergeMap, withLatestFrom } from 'rxjs/operators';
import { ScreenMode } from 'state/quoteWorkspace';
import type { EpicWithThunk } from 'state/state.common';
import { workspaceTabRemovedThunk } from 'state/workspaces/workspace.thunks';
import { sessionSynchronization } from 'utils/streaming/messages';

export function sessionDeletedEpic(): EpicWithThunk {
  return (_action$, state$, { selectors: { getTabIdFromNegotiationId }, streaming }) =>
    sessionSynchronization(streaming).pipe(
      filter(({ type }) => type === 'SessionDeleted'),
      withLatestFrom(state$),
      mergeMap(([sessionEvent, state]) => {
        const negotiationId = sessionEvent.negotiationId;
        const { screenMode, tabId } = getTabIdFromNegotiationId(state, negotiationId);
        if (tabId) {
          if (screenMode === ScreenMode.STATIC) {
            return of(workspaceTabRemovedThunk(tabId, 'static', false));
          } else if (screenMode === ScreenMode.DYNAMIC) {
            return of(workspaceTabRemovedThunk(tabId, 'dynamic', false));
          }
        }
        return EMPTY;
      }),
    );
}
